import axiosInstance from '../../../api/AxiosInstance';
import { endpoints } from '../../../services/endpoints';
import { addMenuRequest, addMenuRequestError, addMenuRequestSuccess } from '../../slices/Menu/AddMenuSlice';


export const AddMenuAPI = (data) => {
    return async (dispatch) => {
        try {
            dispatch(addMenuRequest());
            // Returning the promise so we can await it in handleSubmit
            const response = await axiosInstance({
                method: "POST",
                url: endpoints.addMenu,
                data: data,
            })
            return dispatch(addMenuRequestSuccess(response?.data));
        } catch (error) {
            const _error = {
                data: error?.response?.data?.message || error?.message,
                status: error?.response?.status || error?.status,
            };
            return dispatch(addMenuRequestError(_error));
        }
    };
};
